<shared-navigation-top [title]="title"></shared-navigation-top>

<div class="content animation-fade-in">
  <user-change-password-form></user-change-password-form>
</div>
